// # models
import { SurveyModel } from '@/models';
// # policies
import { SurveyPolicy } from '@/policies';
// # services
import {auth, notifications} from '@/services';

angular.module('app')
    .directive('survey', survey);

survey.$inject = [
    'CommentsApi',
    'Polls',
    'Surveys',
    'PollsApi',
    'PollVotesApi',
    '$timeout',
    '$sce',
    'thisUser',
    'UsersApi',
    'thisSiteSettings',
    'SurveysApi',
    'SurveysAnswersApi',
    '$window',
];

function survey(
    CommentsApi,
    polls,
    surveys,
    PollsApi,
    PollVotesApi,
    $timeout,
    $sce,
    thisUser,
    UsersApi,
    thisSiteSettings,
    SurveysApi,
    SurveysAnswersApi,
    $window,
) {
    function surveyLink($scope) {
        // properties
        $scope.thisSiteSettings = thisSiteSettings;
        $scope.selectedOption = { id: $scope.survey.voted_option_id };
        $scope.expired = +new Date($scope.survey.ends_at) < +new Date();
        $scope.permissionChecks = {
            canManage: SurveyPolicy.canManage(auth.user(), new SurveyModel($scope.survey)),
        };

        if ($scope.selectedOption.id) {
            animate();
        }

        $scope.userId = thisUser ? thisUser.id : null;


        // show responses if set to readOnly
        // if (!$scope.survey.poll.poll_options) {
        $scope.survey.polls.forEach(poll => {

            var data = {
                poll_id: poll.poll_id,
                survey_id: poll.survey_id,
                user_id: $scope.userId,
            };

            //search the poll votes here
            //consider putting this in an await?
            PollVotesApi.get(data, function (response) {
                if (response.data != null) {
                    // eslint-disable-next-line no-param-reassign
                    poll.poll.selectedOption = {
                        id: response.data.poll_option_id,
                        status: response.data.status,
                        deleteid: response.data.id,
                    };
                }
            });

            //get the percentage and total votes
            PollVotesApi.surveyvotes(data, function (response) {
                poll.poll.poll_options.forEach(polloption => {

                    // eslint-disable-next-line no-param-reassign
                    polloption.percentage = 0;
                    // eslint-disable-next-line no-param-reassign
                    polloption.total_votes = 0;
                    if (response.data != null) {

                        let pr = response.data.find(d => d.id === polloption.id);

                        if (pr != undefined) {
                            // eslint-disable-next-line no-param-reassign
                            polloption.total_votes = pr.total_votes;
                            // eslint-disable-next-line no-param-reassign
                            polloption.percentage = pr.percentage;
                        }
                    }
                });
            });
        });

        // methods
        $scope.manage = manage;
        $scope.getDescription = getDescription;

        $scope.submitAnswers = submitAnswers;
        $scope.answers = [];

        //console.log($scope.answered);

        $scope.getLikes = getLikes;
        $scope.getComments = getComments;
        $scope.commentsLoading = false;

        $scope.survey.readonly = !$scope.readOnly;
        $scope.itemType = 'survey';

        $scope.showComments = false;

        $scope.toggleLike = toggleLike;
        $scope.toggleComments = toggleComments;
        $scope.toggleReplyBox = toggleReplyBox;
        $scope.postComment = postComment;
        $scope.deleteComment = deleteComment;
        $scope.updateComment = updateComment;
        $scope.survey.liked = false;

        const replyFormat = {
            id: null,
            parent_id: null,
            body: '',
            entities: [],
            item_id: $scope.survey.id,
            item_type: 'survey',
            saving: false,
        }

        $scope.reply = replyFormat;

        $scope.survey.likes = [];
        $scope.survey.comments = [];
        $scope.survey.surfaceComments = [];
        $scope.survey.realCommentCount = 0;

        $scope.replyBoxOpen = false;
        $scope.replyText = '';

        const commentFilters = {
            filter_by: null,
            order_by: 'created_at',
            order: 'desc',
            page: '1',
            per_page: 250,
            user_id: null,
            item_type: 'poll',
            item_id: $scope.survey.id,
        };

        enum API_ROUTE {
            LIKES = '/api/likes',
            COMMENTS = '/api/comments',
            SURVEYS = '/api/surveys/answer',
            SURVEYS_BASE = '/api/surveys',
        };

        async function submitAnswers(surveyId) {
            if (!$scope.answers) {
                return;
            }

            const answerData = { id: surveyId, answers: $scope.answers, user_id: thisUser.id };
            const endpoint = `${API_ROUTE.SURVEYS_BASE}/${surveyId}/answer`;

            const promise = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(answerData),
            }).then(res => {
                notifications.display({
                    theme: 'success',
                    title: 'Survey answers submitted!',
                    message: '',
                });
                $window.location.reload();
            });

            return Promise.resolve(promise);

            // SurveysAnswersApi.answer(data, function (response) {
            //   console.log(response)
            //   animate();
            // });
        }

        const likedByUser = () => {
            // console.log($scope.survey.likes)
            return $scope.survey.likes.filter(x => x.user_id === thisUser.id).length > 0;
        }

        function getLikes() {
            fetch(`${API_ROUTE.LIKES}?item_id=${$scope.survey.id}&item_type=survey`)
                .then(res => res.json())
                .then(likes => {
                    $scope.survey.likes = likes.data ?? [];
                })
                .finally(() => {
                    $scope.survey.liked = likedByUser();
                    if ($scope.survey.likes.length) {
                        $scope.survey.likes.map(like => {
                            if (!like['user']) {
                                UsersApi.get(
                                    { id: like.user_id },
                                    function handleResponse(response) {
                                        const { full_name, forename, img, slug } = response.data;
                                        like['user'] = { id: like.user_id, full_name, forename, img, slug }
                                    },
                                    null,
                                )
                            }
                        })
                    }
                })
        }

        /**
         * Retrieves an array of comments from the API based on the Poll's ID.
         * @param {string?} parentId (optional) ID of the parent comment.
         * @param {number?} limitTo (optional) Limits the number of comments shown. Defaults to 25.
         * @return {void}
         */
        async function getComments(parentId = null, opts = {}) {
            $scope.commentsLoading = true;
            $scope.reply = replyFormat;

            CommentsApi.get(
                commentFilters,
                response => {
                    const { data } = response;

                    $scope.survey.comments = data;
                    $scope.survey.surfaceComments = $scope.survey.comments.filter(x => x.parent_id === null);

                    if ($scope.survey.comments.length) {
                        $scope.survey.comments.forEach(comment => {
                            comment['isReply'] = comment.parent_id != null;
                            comment['parent'] = null;
                            comment['replies'] = [];

                            if ($scope.survey.likes && $scope.survey.likes.find(x => x.user_id === comment.user_id)) {
                                comment['user'] = $scope.survey.likes.find(x => x.user_id === comment.user_id).user ?? undefined;
                            }

                            if (!comment['user']) {
                                UsersApi.get(
                                    { id: comment.user_id },
                                    function handleResponse(response) {
                                        const { full_name, forename, img, slug } = response.data;
                                        comment['user'] = { id: comment.user_id, full_name, forename, img, slug }
                                    }
                                )
                            }

                            if (comment['isReply']) {
                                comment['parent'] = $scope.survey.comments.find(c => c.id === comment.parent_id) ?? null;
                                comment['parentId'] = $scope.survey.comments.find(c => c.id === comment.parent_id).id ?? null;
                                comment['replies'] = $scope.survey.comments.filter(c => c.parent_id === comment.id);
                            }
                            else {
                                comment['replies'] = $scope.survey.comments.filter(c => c.parent_id === comment.id);
                            }
                        });
                    }

                    $scope.commentsLoading = false;
                },
                error => {
                    console.error('commentsApi.get error:', error)
                }
            )

            await fetch(`${API_ROUTE.COMMENTS}?item_id=${$scope.survey.id}&item_type=survey${parentId ? `&parentId=${parentId}` : ''}`)
                .then(res => res.json())
                .then(comments => {
                    $scope.survey.comments = comments.data;
                    $scope.survey.surfaceComments = $scope.survey.comments.filter(x => x.parent_id === null);
                })
                .then(() => {
                    if ($scope.survey.comments.length) {
                        $scope.survey.comments.forEach(comment => {
                            comment['isReply'] = comment.parent_id != null;
                            comment['parent'] = null;
                            comment['replies'] = [];
                            comment['deleted'] = false;

                            if (comment.isReply && !$scope.survey.comments.find(c => c.id === comment.parent_id)) {
                                comment['deleted'] = true;
                            }

                            if ($scope.survey.likes && $scope.survey.likes.find(x => x.user_id === comment.user_id)) {
                                comment['user'] = $scope.survey.likes.find(x => x.user_id === comment.user_id).user ?? undefined;
                            }

                            if (!comment['user']) {
                                UsersApi.get(
                                    { id: comment.user_id },
                                    function handleResponse(response) {
                                        const { full_name, forename, img, slug } = response.data;
                                        comment['user'] = { id: comment.user_id, full_name, forename, img, slug }
                                    }
                                )
                            }

                            if (comment['isReply']) {
                                comment['parent'] = $scope.survey.comments.find(c => c.id === comment.parent_id) ?? null;
                                comment['parentId'] = $scope.survey.comments.find(c => c.id === comment.parent_id).id ?? null;
                                comment['replies'] = $scope.survey.comments.filter(c => c.parent_id === comment.id);
                            }
                            else {
                                comment['replies'] = $scope.survey.comments.filter(c => c.parent_id === comment.id);
                            }
                        });
                    }
                })
                .finally(() => {
                    $scope.commentsLoading = false;
                })
        }

        async function updateComment(fetchMethod, commentData): Promise<any> {
            if (fetchMethod === 'GET') return false;

            const { id, parentId, itemId, body, entities = [] } = commentData;
            let endpoint = `${API_ROUTE.COMMENTS}`;

            switch (fetchMethod.toUpperCase()) {
                case 'DELETE':
                    endpoint = `${endpoint}/${id}`;
                    break;
                case 'PUT':
                    endpoint = `${endpoint}/${id}?body=${body}`; // IMPLEMENT ENTITIES HERE
                    break;
                case 'POST':
                    endpoint = `${endpoint}?item_type=survey&item_id=${$scope.survey.id}&body=${body}`;
                    if (parentId) endpoint = `${endpoint}&parent_id=${parentId}`;
                    break;
                default:
                    throw Error('[updateComment] Unexpected fetchMethod: ' + fetchMethod);
            }

            // console.log('[updateComment]', 'endpoint', endpoint)
            const promise = await fetch(endpoint, ).then(res => res.json());
            return Promise.resolve(promise);
        }

        function postComment() {
            if ($scope.reply.body) {
                let { id = null, item_id, body } = $scope.reply;
                const method = id != null ? 'PUT' : 'POST';

                $scope.reply.saving = true;

                updateComment(method, { itemId: item_id, body }).then((res) => {
                    // console.log('response', res)
                    $scope.reply = replyFormat;
                    $scope.reply.body = '';
                    $scope.reply.saving = false;
                    toggleReplyBox(false);
                    $scope.getComments();
                })
            }
        }

        function deleteComment(commentId) {
            const comment = $scope.survey.comments.find(c => c.id === commentId);

            if (comment) {
                const method = 'DELETE';
                fetch(API_ROUTE.COMMENTS + `/${commentId}`, { method }).then(() => {
                    $scope.getComments();
                })
            }
        }

        /**
         * Toggles a User's *like* on a Poll
         * @return {void}
         */
        function toggleLike() {
            const method = $scope.survey.liked ? 'DELETE' : 'POST';

            // If isLikedByUser is TRUE then we use the DELETE route with the DELETE method.
            // Otherwise, we use the POST route to creat a new Like.

            const endpoint = $scope.survey.liked
                ? `/${$scope.survey.likes.find(x => x.user_id === thisUser.id).id}`
                : `?item_type=survey&item_id=${$scope.survey.id}`;

            fetch(API_ROUTE.LIKES + endpoint, { method }).then(() => {
                $scope.getLikes();
            })
        }

        /**
         * Toggles the comment box on a Poll (open/closed)
         * @return {void}
         */
        function toggleComments() {
            if (!$scope.showComments) $scope.getComments();
            $scope.showComments = !$scope.showComments;
        }

        function toggleReplyBox(state = null) {
            if (state != null && typeof state !== 'boolean') return;

            if (state === null) {
                return $scope.replyBoxOpen = !$scope.replyBoxOpen;
            }

            return $scope.replyBoxOpen = state;
        }

        /**
         * Forces animation by setting each percentage to 0, then overwriting then the original value
         * @return {void}
         */
        function animate() {
            angular.forEach($scope.survey.poll_options, function (option) {
                var percentage = option.percentage;
                option.percentage = 0;

                $timeout(function () {
                    option.percentage = percentage;
                }, 10);
            });
        }

        /**
         * Opens the manage poll modal.
         * Any edits will be applied to the local scope.
         *
         * @returns {Promise<void>} resolves after edit window is closed.
         */
        function manage(): Promise<void> {
            return new Promise(resolve => {
                surveys.manageSurvey($scope.survey.id)
                    .result
                    .then(updatedSurvey => {
                        if (updatedSurvey) {
                            $scope.survey = updatedSurvey;
                        }
                        resolve();
                    });
            });
        }

        /**
         * Allows full html with styling to be shown - ngSanatize santaizes it
         * @param {string} description
         * @return {string}
         */
        function getDescription(description) {
            return $sce.trustAsHtml(description);
        }

        function bootstrap() {
            $scope.getLikes();
            $scope.getComments();

            document.body.addEventListener('comments:refresh', function () {
                $scope.getComments();
            }, false)

            // document.body.addEventListener('comments:delete', function (event) {}, false)
        }

        bootstrap();
    }

    return {
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'directives/survey.html',
        link: surveyLink,
        scope: {
            survey: '=',
            answered: '=',
            readOnly: '=?',
            userId: '=?',
        },
    };
}
